// src/utils/newsletterApi.js
// Shared by NewsletterForm (homepage/footer) and NewsletterModal (popup).
export async function subscribeToNewsletter(email, source) {
  const res = await fetch('/api/newsletter/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, source }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Something went wrong. Please try again.');
  }
  return data;
}
